import script from "./selectAvatarDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./selectAvatarDialog.vue?vue&type=script&lang=ts&setup=true"

import "./selectAvatarDialog.vue?vue&type=style&index=0&id=093c81d7&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-093c81d7"]])

export default __exports__